<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { simpleRegister } from "@/api";
export default {
  data() {
    return {
      lang: "en",
    };
  },
  watch: {
    lang: {
      handler(val) {
        this.$addStorageEvent(2, "lang", val);
        this.$i18n.locale = val;
        this.$local(val);
        this.$store.commit("setLang", val);
      },
    },
  },
  mounted() {
    window.addEventListener("setItem", (e) => {
      if (e.key === "lang") {
        this.lang = e.newValue;
      }
    });
    this.lang = sessionStorage.getItem("lang");
    this.$i18n.locale = this.lang;
    this.$local(this.lang);

    window.pushIMIE = this.whenImieReceived; // 注册 用于接收imie的回调
    window.disconnectDevice_Succeed = (ignore) => this.$store.commit("setIdOfConnectedDevice", -1); // 注册 断开设备成功回调(宿主是调用方)
    window.sendTheLatestBattery = (enumCode) => this.$store.commit("setTheLatestBattery", enumCode); // 注册 "连接着的设备的最新电量变化" 回调函数
    window.sendTheLatesEJuiceId = (eJuiceId) => this.$store.commit("setTheLatesEJuiceId", eJuiceId); // 注册 "连接着的设备的烟弹改变" 的回调函数
    window.sendTheCusumInhalationTime = (lenOfTime) => this.$store.commit("setTheCusumInhalationTime", lenOfTime); // 注册 "连接着的设备的烟弹累计吸入时长变化" 的回调函数
  },
  methods: {
    /** 当接收到 imie(来自宿主) */
    whenImieReceived(imie) {
      this.$store.commit("setImie", imie);
      simpleRegister({
        imie: this.$store.state.app.imie,
      }).then((res) => {
        this.$toast.success(res.msg);
      });
    },
  },
};
</script>

<style lang="less">
#app {
  font-family: PingFang SC Regular, PingFang SC Regular-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #fafafa;
  min-height: 100vh;
  font-size: 28px;
}
.van-nav-bar {
  background: #fff !important;
  .van-nav-bar__right {
    font-size: 30px;
    color: #000;
    img {
      width: 43px;
      height: 43px;
    }
  }
  .van-nav-bar__title {
    width: 80%;
    max-width: 80%;
    color: #000;
    font-weight: bold !important;
    .van-search {
      .van-icon {
        color: #cfcfcf;
      }
    }
  }
}
.van-button--normal {
  padding: 0 50px;
}
.search-icon {
  width: 36px !important;
  height: 36px !important;
}
.select {
  font-size: 26px;
  line-height: 40px;
  img {
    padding: 0 25px;
    width: 40px;
    height: 40px;
  }
}

.float {
  position: fixed;
  right: 0;
  padding: 0 10px;
  text-align: center;
  min-width: 100px;
  height: 60px;
  line-height: 60px;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 5px 0px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}
.tips_toast {
  width: 55%;
  p {
    font-weight: bold;
    font-size: 28px;
    line-height: 2.5;
  }
  .van-loading {
    margin: 15px 0;
  }
}
</style>
